export class UpdateTurnHolderBetRequest {
    static Message = 'UpdateTurnHolderBetRequest';

    public gameId: string;
    public turnHolderBet: string;

    constructor(gameId: string, turnHolderBet: string) {
        this.gameId = gameId;
        this.turnHolderBet = turnHolderBet;
    }
}

export class UpdateTurnHolderBetResponse {
    static Message = 'UpdateTurnHolderBetResponse';

    public turnHolderBet: string;

    constructor(turnHolderBet: string) {
        this.turnHolderBet = turnHolderBet;
    }
}
